<div class="dialog-wrapper">
  <!-- Header -->
  <div class="dialog-header">
    <button class="close-btn" (click)="onClose()" type="button">&times;</button>
    <h2 class="dialog-title">Payments</h2>
  </div>

  <!-- Body -->
  <div class="dialog-body">
    <!-- Table -->
    <table class="payments-table">
      <thead>
        <tr>
          <th>Invoice</th>
          <th>Payment<br />Date</th>
          <th>Cash<br />Paid</th>
          <th>Visa<br />Paid</th>
          <th>Contactless<br />Cash Paid</th>
          <th>Creator</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let payment of payments">
          <td>{{ payment.invoice }}</td>
          <td>{{ payment.paymentDate }}</td>
          <td>{{ payment.cashPaid }}</td>
          <td>{{ payment.visaPaid }}</td>
          <td>{{ payment.contactlessCashPaid }}</td>
          <td>{{ payment.creator }}</td>
        </tr>
        <tr *ngIf="payments.length === 0">
          <td colspan="6" style="text-align: center; color: #999">
            No payments
          </td>
        </tr>
      </tbody>
    </table>

    <!-- Footer -->
    <div class="dialog-footer">
      <button class="close-footer-btn" (click)="onClose()">Close</button>
    </div>
  </div>
</div>
